import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=2626cddf&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=ts&"
export * from "./activity.vue?vue&type=script&lang=ts&"
import style0 from "./activity.vue?vue&type=style&index=0&id=2626cddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626cddf",
  null
  
)

export default component.exports